/*
  Scopes the existing "secondary image on hover" card effect
  (assets/component-card.css's .media--hover-effect rules) to ONLY
  the photo itself — not the title, price, color swatches, quick-add,
  or wishlist heart below it, even though all of those sit inside the
  same .card-wrapper the effect used to be triggered from.

  Why this can't just be a CSS :hover selector change (and was tried
  first): .card__media and .card__content are siblings inside
  .card__inner, and .card__media is correctly scoped on its own — but
  this store's card markup also carries a full-card invisible overlay
  link (.card__heading a::after, position: absolute) used so clicking
  anywhere on the card, photo included, navigates to the product.
  Depending on which ancestor ends up as that overlay's positioning
  context (card--media vs other card styles give it different
  specificity), native :hover/mouseenter/mouseleave hit-testing on
  .card__media itself is unreliable: the browser's hit-testing always
  resolves to whichever element is topmost at a given pixel, and that
  determination is identical for CSS :hover and JS pointer events
  alike — confirmed directly (not assumed) by testing: .card__media
  never matched :hover even with the mouse dead-center over it.

  Fixed here with a mousemove listener that does its own geometric
  box-overlap test (mouse coordinates vs. .card__media's own
  getBoundingClientRect()) rather than depending on native hover
  hit-testing at all, then toggles a plain class (media-hover-scope-
  active) that assets/component-card.css's rules now key off instead
  of :hover. This works regardless of whatever else happens to be
  stacked on top at that pixel, since it never asks "what element is
  the browser reporting as hovered" — it only asks "is the pointer's
  (x, y) inside this specific box".

  document.elementFromPoint is used first, purely as a cheap way to
  find which card (if any) the pointer is currently over, before doing
  the more precise per-media rect check — this avoids measuring every
  card's .card__media on every single mousemove across the whole page.
  Desktop-only in effect (the CSS it drives is already wrapped in
  @media (min-width: 990px)), but this file doesn't need its own media
  query gate for correctness — it only ever adds work on an actual
  mousemove, which practically doesn't fire from touch interaction the
  same way, and the match-width check below skips the work entirely on
  narrow viewports regardless.
*/
(function () {
  if (window.CardMediaHoverScope) return;

  var ACTIVE_CLASS = 'media-hover-scope-active';
  var DESKTOP_QUERY = window.matchMedia('(min-width: 990px)');
  var currentActiveMedia = null;

  function clearActive() {
    if (currentActiveMedia) {
      currentActiveMedia.classList.remove(ACTIVE_CLASS);
      currentActiveMedia = null;
    }
  }

  function onMouseMove(event) {
    if (!DESKTOP_QUERY.matches) {
      clearActive();
      return;
    }

    var x = event.clientX;
    var y = event.clientY;

    // Whatever's actually topmost at this point (could be the invisible
    // full-card overlay link, could be the image itself, could be
    // something else entirely) — only used to cheaply locate the
    // enclosing card, not trusted for the hover decision itself.
    var hit = document.elementFromPoint(x, y);
    var card = hit && hit.closest ? hit.closest('.card-wrapper') : null;
    var media = card ? card.querySelector('.card__media') : null;

    if (!media) {
      clearActive();
      return;
    }

    var rect = media.getBoundingClientRect();
    var isOverMedia = x >= rect.left && x <= rect.right && y >= rect.top && y <= rect.bottom;

    if (isOverMedia) {
      if (media !== currentActiveMedia) {
        clearActive();
        media.classList.add(ACTIVE_CLASS);
        currentActiveMedia = media;
      }
    } else if (media === currentActiveMedia) {
      clearActive();
    }
  }

  document.addEventListener('mousemove', onMouseMove, { passive: true });
  document.addEventListener('mouseleave', clearActive);
  DESKTOP_QUERY.addEventListener('change', clearActive);

  window.CardMediaHoverScope = {};
})();
